var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('v-container',{attrs:{"fluid":_vm.isRealXl}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"3"}},[_c('search-form')],1),_c('v-col',{attrs:{"cols":"12","md":"9"}},[_c('my-selection-table')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }